import React, { useMemo } from "react";
import { IconMapping } from "./Icon.mapping";
import type { IconProps } from "./types";

/**
 * A component that renders a single icon, which is usually an SVG
 */
export const Icon = ({
  variant,
  size = 20,
  colour,
  weight,
  children,
  alt,
  ...restProps
}: IconProps) => {
  const IconComponent = useMemo(() => IconMapping[variant], [variant]);

  return IconComponent ? (
    <IconComponent
      size={size}
      color={colour}
      weight={weight}
      role="presentation"
      alt={alt}
      {...restProps}
    >
      {children}
    </IconComponent>
  ) : null;
};
